export const fixAssetPath = (url: string) => {
  return url.replace("//_", "/_");
};
